// extracted by mini-css-extract-plugin
export var container = "footer-module--container--f1eb9";
export var item1 = "footer-module--item1--7b410";
export var item2 = "footer-module--item2--5f023";
export var tedxki_container = "footer-module--tedxki_container--39c48";